<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="lg:pb-0 pb-4 w-full">
    <div class="flex w-full gap-4 mb-6">
      <div class="mt-5">
        <vs-icon
          :icon-pack="iconPack"
          :icon="icon"
          round
          class="p-5"
          :color="color"
          :bg="bg"
          style="font-size: 1.5rem"
        ></vs-icon>
      </div>
      <div class="text-left">
        <h2 class="mb-1 font-bold">{{ valorTotal }}</h2>
        <span>{{ titulo }}</span>
      </div>
    </div>
    <hr class="border-solid" style="border-color: #ececec" />
    <div class="flex justify-between mt-4">
      <div class="text-left">
        <h6 style="font-size: 12px">{{ periodoAnterior }}</h6>
        <div class="flex mt-2 gap-2">
          <h6>{{ valorTotalAnterior }}</h6>
        </div>
      </div>
      <div class="text-right">
        <h6 class="font-bold mb-1">Evolução</h6>
        <div class="flex gap-2 justify-end">
          <vs-icon
            class="pt-1 font-bold"
            :color="`${txCrescimento.charAt(0) == '-' ? 'danger' : 'success'}`"
            icon-pack="feather"
            :icon="`${
              txCrescimento.charAt(0) == '-'
                ? 'icon-trending-down'
                : 'icon-trending-up'
            }`"
          ></vs-icon>
          <h5 class="font-bold">{{ txCrescimento }}</h5>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    periodoAnterior: {
      type: [Number, String],
      required: true,
    },
    txCrescimento: {
      type: [Number, String],
      required: true,
    },
    valorTotal: {
      type: [Number, String],
      required: true,
    },
    valorTotalAnterior: {
      type: [Number, String],
      required: true,
    },
    titulo: {
      type: String,
    },
    color: {
      type: String,
      default: 'primary',
    },
    iconPack: {
      type: String,
    },
    bg: {
      type: String,
    },
  },
};
</script>
